import React from "react"
import { 
  Button, 
  OverlayTrigger,
  Tooltip
} from "react-bootstrap"
import {
  HiShieldCheck
} from 'react-icons/hi'
import {
  ButtonCreateInterface
} from '../ButtonCreate'

export const ButtonApprove: React.FC <ButtonCreateInterface> = ({
  text,
  style,
  icon = false,
  noText = false,
  variant,
  tooltip = true,
  tooltipText,
  tooltipPlacement,
  size = 'sm',
  ...rest
}) => {
  return (
    <OverlayTrigger
      placement={tooltipPlacement}
      overlay={tooltip ? <Tooltip>{tooltipText ?? 'Approve data'}</Tooltip> : <div></div>}
    >
      <Button
        {...rest}
        size={size === "sm" ? "sm" : size === "lg" ? "lg" : undefined}
        variant={variant ?? "success"}
        style={{
          ...style,
          minWidth: icon ? 'auto' : '100px' 
        }}
      >
        <div className="d-flex justify-content-center align-items-center">
          <div>
            {icon && <HiShieldCheck className="mb-1" />}
          </div>
          {!noText && (
            <span className="mx-1 text-uppercase">
              {text  ? text : 'Approve'}
            </span>
          )}
        </div>
      </Button>
    </OverlayTrigger>
  )
}